// src/shared/auth/PermissionUtils.ts

import type { CPUserPermissionViewData, IAuthenticatedCPUser } from '@/lib/types/Auth';

/**
 * Pure permission-derivation helpers. UX gating only — the backend stays the
 * authority on every call it receives.
 */
export class PermissionUtils {
  /**
   * Media/management surfaces (Videos, Playlists, Streams, Players, Feeds,
   * Apps) unlock with service read access or the subcustomer pair (legacy
   * TabNavTop media-nav gate).
   */
  static hasMediaAccess(p: CPUserPermissionViewData): boolean {
    return p.serviceRead || (p.subcustomerRead && p.subcustomerWrite);
  }

  /**
   * Upload-only user (legacy "strict uploader"): can ingest but has no media,
   * broadcaster, subcustomer, or admin surfaces. Account-level permissions
   * (billing, users, support) do NOT disqualify — those users get the upload
   * home and keep their Account nav.
   */
  static isUploadOnly(authData: IAuthenticatedCPUser | null): boolean {
    if (!authData) return false;
    const p = authData.cpuser.permissions;
    return (
      p.ingest &&
      !p.serviceRead &&
      !p.serviceWrite &&
      !p.roleBroadcaster &&
      !(p.subcustomerRead && p.subcustomerWrite) &&
      !authData.cpuser.core.isAdmin
    );
  }
}
